<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="零元订单暂估设置"
      width="70%"
      top="8vh"
      append-to-body>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sd/salesRevenueReport/zeroOrderList">
      <div slot="toolbar">
        <el-button type="primary" size="mini" @click="openEdit()">新增配置</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="customerName" align="center" label="客户名称" min-width="160"/>
      <el-table-column prop="estimateAmount" align="center" label="暂估金额(万元)" width="150"/>
      <el-table-column prop="createBy" align="center" label="创建人" width="110"/>
      <el-table-column prop="createTime" align="center" label="创建时间" width="160"/>
      <el-table-column label="操作" align="center" width="140">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>

    <el-dialog
        v-el-drag-dialog
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        :title="editForm.pkid ? '编辑配置' : '新增配置'"
        width="520px"
        append-to-body
        @close="$reset('editForm')">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="110px">
        <el-form-item label="客户" prop="customerName">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="editForm.customerName" placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectCustomer.open()">选择客户</el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </div>
        </el-form-item>
        <el-form-item label="暂估金额(万元)" prop="estimateAmount">
          <el-input-number v-model="editForm.estimateAmount" :min="0" :precision="2" :controls="false" style="width: 100%"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "ZeroOrderDialog",
    components: {VmTable, VmSearch, CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        editVisible: false,
        submitLoading: false,
        filter: {
          customerName: "",
        },
        editForm: {
          pkid: null,
          customerId: null,
          customerName: "",
          estimateAmount: 0,
        },
        editRules: {
          customerName: {required: true, message: "请选择客户", trigger: "blur"},
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      openEdit(row) {
        if (row && row.pkid) {
          this.editForm.pkid = row.pkid;
          this.editForm.customerId = row.customerId;
          this.editForm.customerName = row.customerName;
          this.editForm.estimateAmount = row.estimateAmount;
        } else {
          this.editForm.pkid = null;
          this.editForm.customerId = null;
          this.editForm.customerName = "";
          this.editForm.estimateAmount = 0;
        }
        this.editVisible = true;
      },
      selectCustomer(row) {
        this.editForm.customerId = row.customerID;
        this.editForm.customerName = row.customerName;
      },
      handleSubmit() {
        this.$refs.editForm.validate(valid => {
          if (!valid) {
            return;
          }
          this.submitLoading = true;
          this.$http
            .post("basic", "sd/salesRevenueReport/saveZeroOrder", this.editForm)
            .then(resp => {
              this.submitLoading = false;
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "保存失败");
              }
              this.editVisible = false;
              this.$message.success("保存成功");
              this.getList(-1);
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
      remove(row) {
        this.$confirm("确定删除该配置吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "sd/salesRevenueReport/deleteZeroOrder", null, {pkid: row.pkid})
            .then(resp => {
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "删除失败");
              }
              this.$message.success("删除成功");
              this.getList(-1);
            });
        }).catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
